import React from 'react';
import Icon from '../../../components/AppIcon';

const MessageBubble = ({ message, isUser = false }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp)?.toLocaleTimeString('pt-BR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const renderMessageContent = (content) => {
    // Handle rich content with links and formatting
    if (typeof content === 'object' && content?.type) {
      switch (content?.type) {
        case 'link':
          return (
            <div className="space-y-2">
              <p>{content?.text}</p>
              <a 
                href={content?.url} 
                className="inline-flex items-center space-x-2 p-2 bg-accent bg-opacity-20 rounded-lg text-accent hover:bg-opacity-30 transition-micro"
              >
                <Icon name="ExternalLink" size={14} />
                <span className="text-sm">{content?.linkText}</span>
              </a>
            </div>
          );
        case 'media':
          return (
            <div className="space-y-2">
              <p>{content?.text}</p>
              <div className="w-full h-32 bg-muted rounded-lg flex items-center justify-center">
                <Icon name="Play" size={24} className="text-muted-foreground" />
              </div>
            </div>
          );
        default:
          return <p>{content?.text || content}</p>;
      }
    }
    
    return <p>{content}</p>;
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[85%] ${isUser ? 'order-2' : 'order-1'}`}>
        {/* Avatar for Dai messages */}
        {!isUser && (
          <div className="flex items-start space-x-2">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg viewBox="0 0 24 24" className="w-4 h-4 text-primary-foreground">
                <path 
                  fill="currentColor" 
                  d="M12 2L3.09 8.26L4 21L12 17L20 21L20.91 8.26L12 2Z"
                />
                <circle cx="12" cy="10" r="1.5" fill="var(--color-secondary)" />
              </svg>
            </div>
            <div className="flex-1">
              <div className={`p-3 rounded-lg ${
                isUser 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-card text-card-foreground border border-border shadow-tier-1'
              }`}>
                {renderMessageContent(message?.content)}
              </div>
              <p className="text-xs text-muted-foreground mt-1 ml-2 font-caption">
                {formatTime(message?.timestamp)}
              </p>
            </div>
          </div>
        )}
        
        {/* User messages */}
        {isUser && (
          <div>
            <div className={`p-3 rounded-lg ${
              isUser 
                ? 'bg-primary text-primary-foreground' 
                : 'bg-card text-card-foreground border border-border'
            }`}>
              {renderMessageContent(message?.content)}
            </div>
            <p className="text-xs text-muted-foreground mt-1 text-right font-caption">
              {formatTime(message?.timestamp)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;